import styled, { css } from 'styled-components';
import { DesktopFooter as _DesktopFooter } from '@/components/Footer';
import { HEADER_HEIGHT } from '@/components/Header/Header.constants';
import { removeScrollbar } from '@/styles/helpers';

const sidebarStickyTop = `calc(var(--header-visible-h, ${HEADER_HEIGHT}px) + 40px)`;

export const Page = styled.div`
  min-height: 100dvh;
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const Main = styled.main`
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 30px;
  width: min(100% - 160px, 1280px);
  margin: 0 auto;
  padding: 40px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: min(100% - 60px, 1280px);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    width: 100%;
    padding: 0 0 10px;
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const Sidebar = styled.aside`
  ${removeScrollbar()}

  position: sticky;
  display: flex;
  flex-direction: column;
  align-self: start;
  gap: 25px;
  top: ${sidebarStickyTop};
  height: calc(100dvh - ${sidebarStickyTop});
  overflow-y: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const profileLayoutDesktopFrameStyles = css`
  padding: 30px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const Content = styled.div<{
  $isFramed: boolean;
  $hasCompactHeader?: boolean;
}>`
  align-self: start;

  ${({ $isFramed }) => $isFramed && profileLayoutDesktopFrameStyles}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: ${({ $hasCompactHeader }) =>
      $hasCompactHeader ? '0' : '10px'};
    border-radius: ${({ $hasCompactHeader }) =>
      $hasCompactHeader ? '0 0 21px 21px' : '21px'};

    ${({ $isFramed }) =>
      $isFramed &&
      css`
        padding: 20px 15px;
      `}
  }
`;

export const DesktopFooter = styled(_DesktopFooter)`
  padding: 40px calc((100% - 1280px) / 2) 15px;

  @media (max-width: 1300px) and (min-width: 950px) {
    padding: 40px 80px 15px;
  }
`;
